"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var LinkCountHeader_1 = __importDefault(require("./LinkCountHeader"));
var SearchInput_1 = __importDefault(require("./SearchInput"));
var CreateLinkButton_1 = __importDefault(require("./Buttons/CreateLinkButton"));
var DownloadButton_1 = __importDefault(require("./Buttons/DownloadButton"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        toolBar: (_a = {
                display: 'flex',
                marginTop: theme.spacing(3),
                marginBottom: theme.spacing(2),
                width: '100%'
            },
            _a[theme.breakpoints.down('sm')] = {
                flexWrap: 'wrap',
                marginBottom: theme.spacing(1),
            },
            _a),
    });
});
var ToolBar = function () {
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.toolBar },
        react_1.default.createElement(LinkCountHeader_1.default, null),
        react_1.default.createElement(SearchInput_1.default, null),
        react_1.default.createElement(DownloadButton_1.default, null),
        react_1.default.createElement(CreateLinkButton_1.default, null)));
};
exports.default = ToolBar;
